export default __webpack_public_path__ + "static/media/thumbnail.2b2bbde8.webp";